import { FAVORITE_TAB_PARAM } from '../hooks/useFavoriteTab';

/** Save navigation state only; filters and open-record query parameters are transient. */
export function favoriteTarget(page: { name: string; href: string }, search: string,
  selected?: { tab: string; label: string } | null) {
  const params = new URLSearchParams();
  const nativeTab = new URLSearchParams(search).get('tab');
  if (selected) params.set(FAVORITE_TAB_PARAM, selected.tab);
  else if (nativeTab) params.set('tab', nativeTab);
  const label = selected?.label ?? nativeTab;
  return {
    href: page.href + (params.size ? `?${params}` : ''),
    name: label ? `${page.name} — ${label}` : page.name,
  };
}
